import { postFileResponseSchema } from './schemas';
import type { PostFileRequest, PostFileResponse } from './types';

/**
 * Upload a file to the forms API. Response body is a plain-text URL/path.
 */
export const postFile = async ({
	uploadUrl,
	file,
	fieldName = 'file',
}: PostFileRequest): Promise<PostFileResponse> => {
	const formData = new FormData();
	formData.append(fieldName, file);

	const response = await fetch(uploadUrl, {
		body: formData,
		method: 'POST',
		credentials: 'include',
	});

	if (!response.ok) {
		throw new Error(response.statusText || 'File upload failed');
	}

	const text = await response.text();
	return postFileResponseSchema.parse(text);
};

export const postFileFormData = async (
	uploadUrl: string,
	formData: FormData
): Promise<PostFileResponse> => {
	const response = await fetch(uploadUrl, {
		body: formData,
		method: 'POST',
		credentials: 'include',
	});

	if (!response.ok) {
		throw new Error(response.statusText || 'File upload failed');
	}

	const text = await response.text();
	return postFileResponseSchema.parse(text);
};
